import { Box } from "@mui/material";
import React from "react";
import VoidCityScene from "../components/mapScenes/voidCity/VoidCityScene";
import ArenaScene from "../components/mapScenes/voidCity/ArenaScene";

const Test = () => {
  return (
    <Box sx={{ position: "absolute", width: "100%", height: "100%" }}>
      <VoidCityScene></VoidCityScene>
    </Box>
  );
};

export default Test;
